import axios from "axios";
const baseUrl = process.env.REACT_APP_DXP_BASE_URL;


// Gets all urls for the selected route
export const getUrls = async (route, url, base, additionalParameter) => {
    try {

        const response = await axios.get(`${base}/api/${route}/urls/${url}${additionalParameter ? `/${additionalParameter}` : ''}`);

        return response.data
    } catch (err) {
        console.log(err.message)
    }
};
// ?/_ no symb
export const urlTitleFormatting = async (urlTitle, route, base = baseUrl, additionalParameter = '') => {
    const formattedUrl = urlTitle.replaceAll(/[\`~%^*()=+[{\]}'’";:,|!@#$&?_\/\\]/g, '').replaceAll(' ', '-') //updated with escape characters and what to replace with

    // If only special characters it returns
    if (formattedUrl.length === 0) {
        return { message: 'Invalid name / Url Title' }
    }
    const currentUrls = await getUrls(route, formattedUrl, base, additionalParameter)

    // Checks for matching urls, removing any trailing numbers before checking
    const similarUrls = currentUrls.map(url => url?.url_title?.toLowerCase()).filter(url => url).filter(url => url.replaceAll(/[0-9]+$/g, '') === formattedUrl.toLowerCase().replaceAll(/[0-9]+$/g, ''))

    // Returns url if unique
    if (similarUrls.length === 0) {
        return formattedUrl
    }
    // Array of ending numbers for all similar urls
    const endingNumbers = similarUrls.map(url => url.match(/[0-9]+$/) ? (parseInt(url.match(/[0-9]+$/))) : 0);

    const nextNumber = Math.max(...endingNumbers) + 1

    const endsInNumber = formattedUrl.match(/[0-9]+$/)?.length > 0
    const currentEndingNumber = endsInNumber ? +(formattedUrl.match(/[0-9]+$/)[0]) : null

    // Adds new number to the end of the url if the current ending number is already used
    const newUrl = endingNumbers.includes(currentEndingNumber) ? formattedUrl.replaceAll(/[0-9]+$/g, '') + nextNumber : similarUrls.includes(formattedUrl?.toLowerCase()) ? `${formattedUrl}${nextNumber}` : formattedUrl

    return newUrl
}

// Does not account for only numbers